<template>
    <div v-if="passages_point">
        <h2 class="align_left mb-0">{{ passages_point.nom }}</h2>
        <!-- <StatutCourse :parcours="passages_point"></StatutCourse>
         -->
        <StatistiquesInscritsPoint :parcours="passages_point"></StatistiquesInscritsPoint>
        <UpcomingTimeline :point="passages_point"></UpcomingTimeline>
        <h5 class="text-left mt-3">Par parcours</h5>
        <div v-if="passages_point">
            <CourseBoxItem v-for="parcours in passages_point" :parcours="parcours" :key="parcours.id">
            </CourseBoxItem>
            <!-- <PointCourseItem v-for="point in passages_point.list" :point="point" :key="point.id">
            </PointCourseItem> -->
        </div>
    </div>
</template>

<script>
import StatutCourse from "@/components/Live_tab/Passages/StatutCourse.vue";
import StatistiquesInscritsPoint from "@/components/Live_tab/Passages/StatistiquesInscritsPoint.vue";
import CourseBoxItem from "@/components/Live_tab/Passages/CourseBoxItem.vue";
import PointCourseItem from "@/components/Live_tab/Passages/PointCourseItem.vue";
import UpcomingTimeline from "@/components/Live_tab/Passages/UpcomingTimeline.vue";
export default {
    components: { StatutCourse, StatistiquesInscritsPoint, CourseBoxItem, UpcomingTimeline },
    computed: {
        passages_point() {
            return this.$store.getters['pcCoursePassages/passages_point'];
        }
    }
}
</script>

<style lang="scss" scoped></style>